// 消息通知

import request from '@/utils/request'
// 获取签名list

export function GetSignList(data) {
  return request({
    url: 'SmsManager/GetSignList',
    method: 'get',
    params: data
  })
}
// 保存签名
export function SaveSign(data) {
  return request({
    url: 'SmsManager/SaveSign',
    method: 'post',
    data: data
  })
}

// 审核签名
export function AuditSign(data) {
  return request({
    url: 'SmsManager/AuditSign',
    method: 'post',
    data: data
  })
}
// 启用签名
export function ActiveSign(data) {
  return request({
    url: 'SmsManager/ActiveSign',
    method: 'post',
    data: data
  })
}
// 获取模板列表
export function GetTemplateList(data) {
  return request({
    url: 'SmsManager/GetTemplateList',
    method: 'get',
    params: data
  })
}
// 保存模板
export function SaveTemplate(data) {
  return request({
    url: 'SmsManager/SaveTemplate',
    method: 'post',
    data: data
  })
}
// 启用模板
export function ActiveTemplate(data) {
  return request({
    url: 'SmsManager/ActiveTemplate',
    method: 'post',
    data: data
  })
}
// 审核模板
export function AuditTemplate(data) {
  return request({
    url: 'SmsManager/AuditTemplate',
    method: 'post',
    data: data
  })
}
// 发送短信
export function SendMessage(data) {
  return request({
    url: 'SmsManager/SendMessage',
    method: 'post',
    data: data
  })
}
// 获取短信列表
export function GetMessageList(data) {
  return request({
    url: 'SmsManager/GetMessageList',
    method: 'get',
    params: data
  })
}
// 获取未读的信息
export function GetUserSystemMessages(data) {
  return request({
    url: 'Message/GetUserSystemMessages',
    method: 'get',
    params: data
  })
}
// 设为已读
export function SetMessageToRead(data) {
  return request({
    url: 'Message/SetMessageToRead',
    method: 'post',
    data: data
  })
}
// 设为全部已读
export function SetAllMessagesToRead(data) {
  return request({
    url: 'Message/SetAllMessagesToRead',
    method: 'post',
    data: data
  })
}
// 获取最新信息
export function GetNewUserSystemMessages(data) {
  return request({
    url: 'Message/GetNewUserSystemMessages',
    method: 'get',
    params: data
  })
}

// 获取指定用户的待办任务
export function SearchUserToDoTasks(data) {
  return request({
    url: 'UserTask/SearchUserToDoTasks',
    method: 'get',
    params: data
  })
}

// 查询指定用户各类别汇总统计
export function SearchUserUndoTasks(data) {
  return request({
    url: 'UserTask/SearchUserUndoTasks',
    method: 'get',
    params: data
  })
}

// 获取用来统计的待办条目
export function GetTypeForCountTask(data) {
  return request({
    url: 'UserTask/GetTypeForCountTask',
    method: 'get',
    params: data
  })
}

// 获取消息中心消息分类
export function GetMessageTypeName(data) {
  return request({
    url: 'UserTask/GetMessageTypeName',
    method: 'get',
    params: data
  })
}

// 获取消息列表
export function GetMessageByTypeName(data) {
  return request({
    url: 'UserTask/GetMessageByTypeName',
    method: 'get',
    params: data
  })
}

// 审批待办-汇总页
export function GetMyTodoList(data) {
  return request({
    url: 'approve/JJFlow/GetMyTodoList',
    method: 'get',
    params: data
  })
}

// 首页待办-汇总页 待办的总数
export function GetMyTodoListCount(data) {
  return request({
    url: 'approve/JJFlow/GetMyTodoListCount',
    method: 'get',
    params: data
  })
}

// 获取消息列表
export function GetMyTodoListDetail(data) {
  return request({
    url: 'approve/JJFlow/GetMyTodoListDetail',
    method: 'get',
    params: data
  })
}
